import { TableHeaderItem } from "@/views/components/YtoTable/TableHeaderItem";

const defaultWidth = 300;

const tableHeader: TableHeaderItem[] = [
  { prop: 'index', label: '序号', width: null, fixed: "left" },
  { prop: 'strCode', label: '条码', width: null,  },
  { prop: 'ThreeCode', label: '三段码', width: null,  },
  { prop: 'destOrgCode', label: '目的网点', width: null,  },
  { prop: 'layerNum', label: '层数', width: null,  },
  { prop: 'ScanTime', label: '操作时间', width: null },
  {prop: 'state',label: '上传状态',width:null},
  { prop: 'Info', label: '提示/警告信息', width: null , fixed: "right"},
];
export default { tableHeader }
